"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapSubjectIndirectPercentDiscountIfAs;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _pipeP = _interopRequireDefault(require("../utils/pipeP"));

var _ruleApplicable = _interopRequireDefault(require("../utils/ruleApplicable"));

var _calcPercentDiscountPrice = _interopRequireDefault(require("../utils/calcPercentDiscountPrice"));

var _resolveAndCallStrategy = _interopRequireDefault(require("../resolveAndCallStrategy"));

var _createSubjectIndirectSubjects = _interopRequireDefault(require("../createSubjectIndirectSubjects"));

function mapSubjectIndirectPercentDiscountIfAs(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
  return _mapSubjectIndirectPercentDiscountIfAs.apply(this, arguments);
}

function _mapSubjectIndirectPercentDiscountIfAs() {
  _mapSubjectIndirectPercentDiscountIfAs = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(ctx, rule, subject, targets, innerCondition, percentDiscount, discountProduct) {
    var prevPrice, discPrice, result;
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            prevPrice = subject.price;
            _context6.next = 3;
            return (0, _calcPercentDiscountPrice.default)(prevPrice, percentDiscount);

          case 3:
            discPrice = _context6.sent;
            _context6.next = 6;
            return (0, _pipeP.default)( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(subjects) {
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        return _context.abrupt("return", subjects.filter(function (s) {
                          return !s.ruleFootprint;
                        }));

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x8) {
                return _ref.apply(this, arguments);
              };
            }(), /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(subjects) {
                return _regenerator.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", Promise.all(subjects.map((0, _ruleApplicable.default)(ctx, {
                          targets: targets
                        }))));

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x9) {
                return _ref2.apply(this, arguments);
              };
            }(), /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(applicable) {
                return _regenerator.default.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", applicable.reduce(function (r, _ref4) {
                          var _ref5 = (0, _slicedToArray2.default)(_ref4, 3),
                              e = _ref5[0],
                              isa = _ref5[1],
                              sbj = _ref5[2];

                          return !e && isa ? [].concat((0, _toConsumableArray2.default)(r), [sbj]) : r;
                        }, []));

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x10) {
                return _ref3.apply(this, arguments);
              };
            }(), /*#__PURE__*/function () {
              var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(applicableSubjects) {
                return _regenerator.default.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        return _context4.abrupt("return", (0, _resolveAndCallStrategy.default)(ctx, 'innerCondition', innerCondition, {
                          subjects: applicableSubjects
                        }));

                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function (_x11) {
                return _ref6.apply(this, arguments);
              };
            }(), /*#__PURE__*/function () {
              var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(isConditionTrue) {
                return _regenerator.default.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        return _context5.abrupt("return", (0, _createSubjectIndirectSubjects.default)(ctx, rule, isConditionTrue ? discountProduct : null, discPrice - prevPrice));

                      case 1:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x12) {
                return _ref7.apply(this, arguments);
              };
            }())(ctx.cart.subjects);

          case 6:
            result = _context6.sent;
            return _context6.abrupt("return", (0, _extends2.default)({}, result));

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _mapSubjectIndirectPercentDiscountIfAs.apply(this, arguments);
}